import React, { FC } from 'react'
import useSWR from 'swr'

import { fetchLoanApplication } from 'facades/fetchLoanApplication'

const EmailAndCellphone: FC<{ applicationId: string }> = ({
  applicationId,
}) => {
  const { data } = useSWR(['loan-application', applicationId], () =>
    fetchLoanApplication(applicationId),
  )

  return (
    <>
      <p>{data?.cellphone}</p>
      <p>{data?.email}</p>
    </>
  )
}

export { EmailAndCellphone }
